interface BioProps {
  bio: string;
}

export default function Bio({ bio }: BioProps) {
  return (
    <div>
      <h3 className="hidden font-medium text-18/[1.5em] text-white md:block">
        Bio
      </h3>
      <section className="mt-[15px] rounded-[10px] bg-white/5 p-5 md:mt-5">
        <p className="whitespace-pre-line text-13/[1.85em] text-pale-lavender">
          {bio}
        </p>
      </section>
    </div>
  );
}
